import { AuthSettings } from './types'

export const getLoginCallbackUrl = (authSettings: AuthSettings) => {
    const { loginCallbackUrl } = authSettings

    if (loginCallbackUrl) {
        return loginCallbackUrl
    }

    const currentUrl = new URL(window.location.href)
    return `${currentUrl.origin}/auth/callback`
}

export const getLogoutCallbackUrl = (authSettings: AuthSettings) => {
    const { logoutCallbackUrl } = authSettings

    if (logoutCallbackUrl) {
        return logoutCallbackUrl
    }

    const currentUrl = new URL(window.location.href)
    return currentUrl.origin
}
